/* eslint-disable */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Spin } from 'antd';
import { HomeOutlined, InfoCircleOutlined } from '@ant-design/icons';
import './BitacoraNotificacion.scss';
import { selectBitacoraNotificacionState } from 'selectors/bitacoraNotificacion.selector';
import { BuscadorBitacoraNotificacion } from './components/BuscadorBitacoraNotificacion/BuscadorBitacoraNotificacion';
import { TablaBitacoraNotificacion } from './components/TablaBitacoraNotificacion/TablaBitacoraNotificacion';

export function BitacoraNotificacion() {
  const { loading } = useSelector(selectBitacoraNotificacionState);
  const [mainFilters, setMainFilters] = useState({});

  const showTotal = (total, range) => {
    return `Mostrando del ${range[0]} al ${range[1]} de ${total} registros`;
  };

  const [pagination, setPagination] = useState({
    position: ['bottomRight'],
    showQuickJumper: true,
    size: 'small',
    pageSize: 10,
    current: 1,
    showTotal,
    total: 0,
    showSizeChanger: false
  });

  return (
    <div className="bitacora-notificacion">
      <Spin spinning={loading}>
        <div>
          <HomeOutlined style={{ fontSize: '13px' }} /> |{' '}
          <span style={{ color: '#AAAAAA', fontSize: '13px' }}>Reportes</span> |{' '}
          <span style={{ color: '#c12b7d', fontSize: '13px' }}>Bitácora de notificación</span>
        </div>
        <h1 className="title-label">Bitácora de notificación</h1>
        <div className="message-label">
          <span>
            <InfoCircleOutlined style={{ color: '#c12b7d', marginRight: '0.5rem' }} />
            Selecciona los campos para realizar la búsqueda.
          </span>
          <span style={{ color: 'red' }}> *Campos obligatorios.</span>
        </div>
        <br />
        <BuscadorBitacoraNotificacion
          onSearch={(filtros) => {
            setMainFilters(filtros);
            setPagination((prev) => ({ ...prev, current: 1 }));
          }}
        />
        <TablaBitacoraNotificacion
          mainFilters={mainFilters}
          pagination={pagination}
          setPagination={setPagination}
        />
      </Spin>
    </div>
  );
}

export default BitacoraNotificacion;
